import styled from "styled-components";



export const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 10px 20px 50px 30px;
  box-sizing: border-box;
  position: relative;
`
